import script from "./loginMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./loginMessage.vue?vue&type=script&setup=true&lang=ts"

import "./loginMessage.vue?vue&type=style&index=0&id=86ec3876&scoped=true&lang=css"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86ec3876"]])

export default __exports__